import React, { useCallback, useEffect, useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import FilterEvent from "./components/FilterEvent";
import TableEvent from "./components/TableEvent";
import { axios, getToken, URL_API } from "../../../../utils";
import { message, Spin } from "antd";

const LegacyChannel = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    event_id: "",
    source: "",
    search: "",
    limit: 10,
    offset: 0,
  });
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${URL_API}/channel`, {
        params: searchParams,
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      });
      setData(res.data);
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  }, [searchParams]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <Panel>
      <PanelHeader>ตั้งค่า Legacy Channel</PanelHeader>
      <Spin spinning={loading}>
        <PanelBody>
          <FilterEvent
            setLoading={(val) => setLoading(val)}
            setSearchParams={(val) => setSearchParams(val)}
            list={data}
          />
          <TableEvent
            tableData={data}
            fetchData={(params) => fetchData(params)}
            setLoading={(val) => setLoading(val)}
            searchParams={searchParams}
            setSearchParams={(val) => setSearchParams(val)}
          />
        </PanelBody>
      </Spin>
    </Panel>
  );
};
export default LegacyChannel;
